<template>

  <t-dialog-form :generalErrors="generalErrors" :title="dialogTitle" :hide-submit="localStatus === 'subject'"
                 :ok-text="okText" @show="showModal" :disabled-submit="disabledSubmit" @hidden="onCloseModal"
                 :id="id" :command="command" :status="status" :variant="variant"
                 ref="dialog_form" @onSubmit="onSubmit">


    <b-card-title v-if="headerTitle.length > 0">{{ headerTitle }}</b-card-title>


    <div v-if="localStatus === ''">


      <slot>

      </slot>


    </div>


    <div class="job-status-box" v-else-if="localStatus === 'subject'">

      <t-msg info v-if="job.status !== 'SUCCESS'">Por favor aguarde o término do processamento nesta tela</t-msg>

      <div class="d-flex align-items-center justify-content-between mb-2">
        <div class="d-flex align-items-center">
          <b-badge :variant="statusUi.variant" class="mr-2">
            {{ statusUi.label }}
          </b-badge>

          <small class="text-muted">
            {{ statusUi.hint }}
          </small>
        </div>

        <b-icon :icon="statusUi.icon" :variant="statusUi.variant" font-scale="1.2"></b-icon>
      </div>

      <b-progress height="10px" class="mb-2">
        <b-progress-bar
            :variant="statusUi.variant"
            :striped="statusUi.isIndeterminate"
            :animated="statusUi.isIndeterminate"
            :value="statusUi.isIndeterminate ? 100 : statusUi.value"
        />
      </b-progress>

      <!-- Mensagem do back (quando existir) -->
      <div v-if="job.message" class="mt-2">
        <div
            class="alert mb-0"
            :class="(job.status === 'ERROR' || job.status === 'TIMEOUT') ? 'alert-danger' : 'alert-secondary'"
        >
          {{ job.message }}
        </div>
      </div>

      <!-- Downloads: somente em SUCCESS (voc&ecirc; pode plugar as URLs depois) -->
      <div v-if="job.status === 'SUCCESS'" class="d-flex flex-wrap mt-3">
        <t-button
            primary
            :disabled="disabledButtonDownloadWord"
            @click="getWordFile('docx')"
            class="mr-2 mb-2"
        >
          <b-icon-file-earmark-word class="mr-1" />
          Download Word
        </t-button>

        <t-button
            @click="getWordFile('pdf')"
            :disabled="disabledButtonDownloadPDF"
            class="mb-2"
            v-if="enablePDF"
        >
          <b-icon-file-earmark-pdf class="mr-1" />
          Download PDF
        </t-button>
      </div>

    </div>


  </t-dialog-form>

</template>
<script>
import tDialogForm from "@/components/template/dialog/t-dialog-form";
import pageDialogFormMixin from "@/mixins/page/pageDialogFormMixin";
import http from "@/services/config/http-common";
import ui from "@/assets/scripts/ui";


export default {
  name: "WordServiceRunDialog",
  components: {tDialogForm},
  mixins: [pageDialogFormMixin],
  data() {
    return {
      id: "modal-word-service-run",
      okText: "Gerar Word",
      error: {//Campos que podem receber retorno de erro do backend
        name: "",
      },
      variant: "primary",
      label: {},
      printerDefault: {},
      printerOptions: [],
      localStatus: "",
      disabledButtonDownloadWord: false,
      disabledButtonDownloadPDF: false,
    }
  },
  props: {
    fileName: {
      type: String,
      default: "relatorio",
    },
    disabledSubmit: Boolean,
    enablePDF: Boolean,
    dialogTitle: { //Titulo da
      type: String,
      default: "",
    },
    job: Object,
    headerTitle: { //Titulo da
      type: String,
      default: "",
    },
  },
  mounted() {

  },

  methods: {

    //Declaro sempre localmente, pois poderá realizar operações diferentes do padrão como setar algum valor padrão vindo de fora e que seria limpo pelo resetModal de forma dinamica
    async showModal() {

      //Limpa os campos
      this.resetModal()
      this.localStatus = ""

      this.$emit('show')

    },

    async onSubmit() {

      this.localStatus = "subject"
      this.$emit('onSubmit')

    },

    async getWordFile(extension = 'docx') {

      let complement

      if (extension === "docx") {
        complement = 'download'
        this.disabledButtonDownloadWord = true
      } else {
        complement = 'pdf'
        this.disabledButtonDownloadPDF = true
      }

      const post = {
        fileName: this.fileName
      }

      await http.downloadPost(
          "/resource/word/jobs/" + this.job.jobId + '/' + complement, this.fileName + '.' + extension, post
      ).catch(error => ui.generalResponseError(this, error))

      if (extension === "docx") {
        this.disabledButtonDownloadWord = false
      } else {
        this.disabledButtonDownloadPDF = false
      }

    },

    onCloseModal() {
      this.$emit('hide')
    },

  },
  computed: {

    statusUi() {
      const s = (this.job.status || "").toUpperCase();

      const base = {
        value: 100,
        isIndeterminate: true,
        hint: "Processando..."
      };

      if (s === "QUEUED") {
        return {...base, label: "Fila", variant: "secondary", icon: "clock", hint: "Na fila de processamento."};
      }
      if (s === "RUNNING") {
        return {...base, label: "Pendente", variant: "info", icon: "arrow-repeat", hint: "Processando relatório."};
      }
      if (s === "PENDING_PDF") {
        return {
          ...base,
          label: "PDF",
          variant: "warning",
          icon: "file-earmark-pdf",
          hint: "Gerando PDF do documento."
        };
      }
      if (s === "SUCCESS") {
        return {
          value: 100,
          isIndeterminate: false,
          label: "Sucesso",
          variant: "success",
          icon: "check-circle",
          hint: "Finalizado com sucesso."
        };
      }
      if (s === "TIMEOUT") {
        return {
          ...base,
          label: "Tempo encerrado",
          variant: "danger",
          icon: "exclamation-triangle",
          hint: "Tempo excedido no processamento."
        };
      }
      if (s === "ERROR") {
        return {...base, label: "Erro", variant: "danger", icon: "x-circle", hint: "Falha no processamento."};
      }

      return {...base, label: s || "Pendente", variant: "dark", icon: "question-circle", hint: "Status desconhecido."};
    }
  },
}
</script>
